var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompagnySettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 2.33325H10.5C9.21317 2.33325 8.16667 3.37975 8.16667 4.66659V11.6666H5.83333C4.5465 11.6666 3.5 12.7131 3.5 13.9999V24.4999C3.5 24.8093 3.62292 25.1061 3.84171 25.3249C4.0605 25.5437 4.35725 25.6666 4.66667 25.6666H23.3333C23.6428 25.6666 23.9395 25.5437 24.1583 25.3249C24.3771 25.1061 24.5 24.8093 24.5 24.4999V4.66659C24.5 3.37975 23.4535 2.33325 22.1667 2.33325ZM5.83333 13.9999H12.8333V23.3333H5.83333V13.9999ZM22.1667 23.3333H15.1667V13.9999C15.1667 12.7131 14.1202 11.6666 12.8333 11.6666H10.5V4.66659H22.1667V23.3333Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 7H15.1667V9.33333H12.8333V7ZM17.5 7H19.8333V9.33333H17.5V7ZM17.5 11.7028H19.8333V14H17.5V11.7028ZM17.5 16.3333H19.8333V18.6667H17.5V16.3333ZM8.16667 16.3345H10.5V18.6678H8.16667V16.3345Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompagnySettingsIcon);
export default __webpack_public_path__ + "static/media/compagny_settings-icon.1d3691bc15a147531df5d4d0513007aa.svg";
export { ForwardRef as ReactComponent };